// Page size for the blog index.
//
// CommonJS on purpose: this is imported by the Blog component at runtime and
// require()d by scripts/generate-snap-routes.js and
// scripts/generate-blog-index.js at build time. Keeping one definition means
// the prerendered routes and the sitemap can never disagree with what the
// component actually paginates.
const POSTS_PER_PAGE = 6;

// Page 1 lives at /blog/ (not /blog/page/1/) so the canonical listing URL
// never changes and existing links keep working.
function blogPagePath(prefix, page) {
  return page <= 1 ? `${prefix}/blog/` : `${prefix}/blog/page/${page}/`;
}

function totalBlogPages(postCount) {
  return Math.max(1, Math.ceil(postCount / POSTS_PER_PAGE));
}

module.exports = { POSTS_PER_PAGE, blogPagePath, totalBlogPages };
